import { render, staticRenderFns } from "./PartnerCardSkeleton.vue?vue&type=template&id=487d4fe6&scoped=true"
import script from "./PartnerCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PartnerCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PartnerCardSkeleton.vue?vue&type=style&index=0&id=487d4fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d4fe6",
  null
  
)

export default component.exports